import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PrivateViewsRoutes } from './private-views.routes';
import { PrivateViewsComponent } from './private-views.component';
/** */
import { AppAsideModule } from '../shared/components/app-aside/app-aside.module';
import { AppHeaderModule } from '../shared/components/app-header/app-header.module';
import { AppSidebarModule } from '../shared/components/app-sidebar/app-sidebar.module';
import { AppFooterModule } from '../shared/components/app-footer/app-footer.module'
import { AppBreadcrumbsModule } from '../shared//components/app-breadcrumbs/app-breadcrumbs.module';
/** */
@NgModule({
  declarations: [
    PrivateViewsComponent
  ],
  imports: [
    BrowserModule,
    RouterModule,
    AppAsideModule,
    AppHeaderModule,
    AppSidebarModule,
    AppFooterModule,
    AppBreadcrumbsModule,
    PrivateViewsRoutes
  ],
  exports: [PrivateViewsComponent]
})
export class PrivateViewsModule { }



// WEBPACK FOOTER //
// ./src/app/private-views/private-views.module.ts